// Mock data for the descoping Caseloads view — last-activity dates and the
// activity log. Stands in for the list + activity APIs. Circle ids match the
// care circles index (care-circles/fixtures.ts) so the two describe the same
// circles.

export type CaseloadActivity = {
  id: string;
  // What happened, e.g. 'Submitted financial assessment'.
  action: string;
  // The care circle it happened on, keyed by circle id.
  circleId: string;
  // Display date, e.g. '18 Jul 2026'.
  date: string;
};

// Last activity date per circle, keyed by circle id.
export const LAST_ACTIVITY: Record<string, string> = {
  'CC-4821': '18 Jul 2026',
  'CC-4805': '16 Jul 2026',
  'CC-4790': '15 Jul 2026',
  'CC-4776': '10 Jul 2026',
  'CC-4761': '17 Jul 2026',
  'CC-4748': '12 Jul 2026',
  'CC-4732': '9 Jul 2026',
  'CC-4719': '14 Jul 2026',
};

// The activity log, newest first. Each entry links back to its care circle.
export const ACTIVITY_LOG: CaseloadActivity[] = [
  {
    id: 'a1',
    action: 'Submitted financial assessment',
    circleId: 'CC-4821',
    date: '18 Jul 2026',
  },
  {
    id: 'a-secured-elsewhere',
    action: 'Secured care elsewhere',
    circleId: 'CC-4821',
    date: '18 Jul 2026',
  },
  {
    id: 'a2',
    action: "Uploaded 'Power of attorney.pdf'",
    circleId: 'CC-4790',
    date: '17 Jul 2026',
  },
  {
    id: 'a3',
    action: "Completed 'Review shortlist'",
    circleId: 'CC-4821',
    date: '16 Jul 2026',
  },
  {
    id: 'a4',
    action: 'Booked a funding call',
    circleId: 'CC-4790',
    date: '15 Jul 2026',
  },
  {
    id: 'a5',
    action: 'Secured Oakwood Care Home',
    circleId: 'CC-4821',
    date: '12 Jul 2026',
  },
  {
    id: 'a6',
    action: 'Added a watcher',
    circleId: 'CC-4790',
    date: '10 Jul 2026',
  },
];
